export enum UADimensionProperty {
    STR = 'str',
    NUM = 'num',
    TS = 'ts'
}
